module.exports = __webpack_public_path__ + "static/media/en_graphic_permacool.de612aed.jpeg";